import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/eye.png'
import _imports_1 from '../assets/img/arr-right.png'


const _withScopeId = n => (_pushScopeId("data-v-1f0f9a12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "article bx" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "sub-title" }
const _hoisted_5 = { class: "name fl" }
const _hoisted_6 = { class: "time fl" }
const _hoisted_7 = { class: "iview fr" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "opt-box"
}
const _hoisted_11 = {
  key: 0,
  class: "btn",
  href: "/article?articleId=17"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "公益捐款", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "公益跑团", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "公益读书", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 3,
  class: "btn",
  href: "/live"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "公益直播", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "join-box"
}
const _hoisted_26 = {
  key: 1,
  class: "join-btn dis"
}
const _hoisted_27 = {
  key: 2,
  class: "pagination"
}
const _hoisted_28 = { class: "join-to" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "本次活动免费报名参加", -1))
const _hoisted_30 = { class: "input-box" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "报 名 人", -1))
const _hoisted_32 = { class: "input-box" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "联系手机", -1))
const _hoisted_34 = { class: "input-box" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "备 注", -1))
const _hoisted_36 = { class: "btn-box" }

import {
  MessageFetch,
  StoryFetch,
  searchInfo,
  UserService
} from '@/api/request';
import LoginToast from '@/components/loginToast.vue';
import {
  ISjqnwArticleProps,
  IStoryDescProps,
  SjqnwArticleProps,
  ScholarshipStoryInfoProps
} from '@/api/type';
import Recommend from '@/components/Recommend.vue';
import { Toast } from 'vant';
import { nextTick, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import config from '../_config';
import { ElMessage } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const show = ref(false);
const scholarshipIds = router?.currentRoute?.value?.query?.scholarshipId;
const articleIds = router?.currentRoute?.value?.query?.articleId;
const type = router?.currentRoute?.value?.query?.type;
const articleId = Array.isArray(articleIds)
  ? (articleIds[0] as string)
  : articleIds || '';
const scholarshipId = Array.isArray(scholarshipIds)
  ? (scholarshipIds[0] as string)
  : scholarshipIds || '';
const artDetail = ref<SjqnwArticleProps>();
const storyDetail = ref<IStoryDescProps>();
const scholarshipStoryInfo = ref<ScholarshipStoryInfoProps>();
const showLogin = ref(false);
const userName = ref('');
const signUpMobile = ref('');
const remark = ref('');
const userId = window.localStorage.getItem('userId') || '';
const isSignUp = ref(false);
const sjqnwArticleType = ref('');

const IsPC = () => {
  var userAgentInfo = navigator.userAgent;
  var Agents = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod'
  ];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
};
const onClickTag = (id: string, title: string, articleId: string) => {
  const params = {
    eventId: id,
    eventTitle: title,
    redundancyFields: articleId,
    channel: IsPC() ? '1' : '2'
  };
  UserService.sjqnwStatistics(params);
};
const init = async() => {
  const authToken = window.localStorage.getItem('authToken') || '';

  if (scholarshipId) {
    const storyRes = await StoryFetch.getStoryDetail({
      scholarshipId,
      authToken
    });
    if (storyRes.code === '00') {
      storyDetail.value = storyRes.body[0];
      onClickTag('23', storyDetail.value?.articleTitle, scholarshipId);
      const resourcesUrl = storyRes.body[0]?.resourcesUrl;
      const $script = document.createElement('script');
      $script.type = 'text/javascript';
      $script.charset = 'utf-8';
      $script.src = config.articleUrl + resourcesUrl;
      $script.onload = () => {
        scholarshipStoryInfo.value = window?.storyInfo;
        if (document.body.clientWidth < 993) {
          nextTick(() => {
            // 写入操作
            const oImg = document.querySelectorAll('img');

            for (var i = 0; i < oImg.length; i++) {
              oImg[i].style.maxWidth = '80vw';
              oImg[i].style.maxHeight = 'auto';
            }
            // 写入操作
            const Pi = document.querySelectorAll('p');
            for (var e = 0; e < Pi.length; e++) {
              Pi[e].style.width = 'auto';
            }
          });
        }
      };
      window.document.body.appendChild($script);
      await StoryFetch.updateReadNum({ scholarshipId });
    }
  } else {
    const res = await MessageFetch.getArticleDetail({
      sjqnwArticleType: '1',
      id: articleId
    });
    if (res.code === '00') {
      artDetail.value = res.body;
      onClickTag('23', artDetail.value?.articleTitle, articleId);
      isSignUp.value = res.body.isSignUp;
      sjqnwArticleType.value = res.body.sjqnwArticleType;
      nextTick(() => {
        // 写入操作
        const oImg = document.querySelectorAll('img');

        for (var i = 0; i < oImg.length; i++) {
          oImg[i].style.maxWidth = '80vw';
          oImg[i].style.maxHeight = 'auto';
        }
        // 写入操作
        const Pi = document.querySelectorAll('p');
        for (var e = 0; e < Pi.length; e++) {
          Pi[e].style.width = 'auto';
        }
      });
      await MessageFetch.sjqnwArticleBrowse({ id: articleId });
    }
  }
};

const toRouter = (type: any) => {
  if (window.localStorage.getItem('authToken')) {
    router.push({
      path: '/welfareActivity',
      query: {
        welfareType: type
      }
    });
  } else {
    showLogin.value = true;
  }
};

const signUp = async() => {
  if (!window.localStorage.getItem('authToken')) {
    Toast('请先登录');
    return;
  }
  if (!signUpMobile.value || !userName.value) {
    Toast('请填写完整信息');
    return;
  }
  var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  if (!myreg.test(signUpMobile.value)) {
    ElMessage.error('请输入正确的手机号');
    return;
  }

  const data = {
    mobile: window.localStorage.getItem('mobile') || '',
    remark: remark.value,
    artcleId: articleId,
    signUpMobile: signUpMobile.value,
    userName: userName.value,
    userId: userId
  };
  const res = await searchInfo.sjqnwArticleSignUp(data);
  if (res.code === '00') {
    Toast('报名成功');
    show.value = false;
    remark.value = '';
    userName.value = '';
    init();
  }
};

const like = async() => {
  if (scholarshipId) {
    const res = await StoryFetch.updateFabulousNum({
      fabulousNum: storyDetail.value?.fabulous ? -1 : 1, // （用户第一次触发传1 第二触发取消点赞传 -1）
      scholarshipId: storyDetail.value?.scholarshipId || ''
    });
    if (res.code === '00') {
      storyDetail.value.fabulous = !storyDetail.value.fabulous;
    }
  } else {
    const resFabulous = await StoryFetch.sjqnwArticleGiveLike({
      likeType: artDetail.value?.like ? -1 : 1, // （用户第一次触发传1 第二触发取消点赞传 -1）
      id: artDetail.value?.id || ''
    });
    if (resFabulous.code === '00') {
      artDetail.value.like = !artDetail.value.like;
    }
  }
};

// 参与挑战
const join = () => {
  if (window.localStorage.getItem('authToken')) {
    show.value = true;
  } else {
    showLogin.value = true;
  }
};

const toDetail = (item?: ISjqnwArticleProps) => {
  router.push({
    name: 'article',
    query: { articleId: item?.id }
  });
};
const toRun = () => {
  router.push({
    name: 'welfareActivity',
    query: { type: 3 }
  });
};
onMounted(() => {
  init();
});

return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(artDetail.value?.articleTitle || storyDetail.value?.articleTitle), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(artDetail.value?.author || '原创'), 1),
        _createElementVNode("div", _hoisted_6, " 更新日期：" + _toDisplayString(artDetail.value?.updateTime || storyDetail.value?.updateTime), 1),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(" " + _toDisplayString(artDetail.value?.readNumber || storyDetail.value?.readNum), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: "detail",
        innerHTML: artDetail.value?.content || scholarshipStoryInfo.value?.textPre
      }, null, 8, _hoisted_9),
      (sjqnwArticleType.value !== '3')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_unref(type))
              ? (_openBlock(), _createElementBlock("a", _hoisted_11, _hoisted_14))
              : _createCommentVNode("", true),
            (_unref(type) == 'run')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (toRouter(3)))
                }, _hoisted_17))
              : _createCommentVNode("", true),
            (_unref(type) == 'book')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  class: "btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (toRouter(2)))
                }, _hoisted_20))
              : _createCommentVNode("", true),
            (_unref(type) == 'live')
              ? (_openBlock(), _createElementBlock("a", _hoisted_21, _hoisted_24))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (sjqnwArticleType.value == '3')
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            (!isSignUp.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "join-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (join()))
                }, " 报名参加 "))
              : (_openBlock(), _createElementBlock("button", _hoisted_26, "已报名"))
          ]))
        : _createCommentVNode("", true),
      (artDetail.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            (artDetail.value?.sjqnwPreArticle?.id)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "pagination-item",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (toDetail(artDetail.value?.sjqnwPreArticle)))
                }, " 上一篇：" + _toDisplayString(artDetail.value?.sjqnwPreArticle.articleTitle), 1))
              : _createCommentVNode("", true),
            (artDetail.value?.sjqnwNextArticle?.id)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "pagination-item",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (toDetail(artDetail.value?.sjqnwNextArticle)))
                }, " 下一篇：" + _toDisplayString(artDetail.value?.sjqnwNextArticle.articleTitle), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Recommend),
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((show).value = $event)),
      closeable: "",
      round: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((userName).value = $event)),
              id: "name",
              type: "text",
              placeholder: "请输入姓名"
            }, null, 512), [
              [_vModelText, userName.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((signUpMobile).value = $event)),
              placeholder: "请输入手机号码",
              maxlength: "11"
            }, null, 512), [
              [_vModelText, signUpMobile.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((remark).value = $event)),
              rows: "10",
              cols: "30",
              maxlength: "50",
              placeholder: "请输入备注信息（选填）"
            }, null, 512), [
              [_vModelText, remark.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("button", {
              class: "cancel",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (show.value = false))
            }, "取消"),
            _createElementVNode("button", {
              class: "confirm",
              onClick: signUp
            }, "立即报名")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(LoginToast, {
      showLogin: showLogin.value,
      "onUpdate:confirm": _cache[10] || (_cache[10] = ($event: any) => (showLogin.value = false))
    }, null, 8, ["showLogin"])
  ]))
}
}

})